import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { TaxRateShiftsDto } from '../dtos';

@Injectable()
export class TaxRateShiftsService {
  private path = 'versionedupdate/taxrateshifts';
  constructor(private httpService: HttpService) {}

  public getTaxRateShifts(versionHash: string): Observable<VersionedData<TaxRateShiftsDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
